// Per-application "Done vs To do" flags for the client Dashboard tiles.
// Populated by fetchTaskStatus → POST /api/client/taskStatus, which mirrors
// the admin Tracking page's completion logic via server/modules/taskStatus.js.
const INIT_STATE = {
    fact_find: false,
    id: false,
    docs: false,
    bankstatements: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'SET_TASK_STATUS':
            return {
                ...INIT_STATE,
                ...(action.payload || {})
            };
        default:
            return state;
    }
};
